<template>
  <div class="main">
      <tab title='司机列表'></tab>
      <div class="select_box">
         <van-search
            v-model="value"
            placeholder="请输入司机姓名搜索"
            input-align="center"
            @input="selectDrive"
        />
      </div>
      <div class="card_list" v-if="list.length>0">
          <div v-for="item in list" v-bind:key="item.id" class="card" @click="toDetail(item)">
              <div class="cardNo">
                  司机名称：{{item.driverName}}
              </div>
              <div class="oli">
                  手机号码：{{item.mobile}}
              </div>
              <div class="oli">
                  余额：{{item.balance}}
              </div>
              <div class="oli">
                  管控模式：{{item.carLimit==1?'不受限':'受限'}}
              </div>
              <div class="oli">
                  认证状态：{{item.actStatus==1?'已认证':'未认证'}}
              </div>
              <div class="oli">
                  状态：<span :class="item.status==1?'lv':'red'">{{item.status==1?'启用':'禁用'}}</span>
              </div>
              <div class="btn_box">
                  <div class="info_btn" @click="toDetail(item)">操作</div>
              </div>
          </div>
          <!-- <div class="card">
              <div class="cardNo">
                  司机名称：张三
              </div>
              <div class="oli">
                  手机号码：150000001
              </div>
              <div class="oli">
                  余额：300.00
              </div>
              <div class="oli">
                  管控模式：不受限
              </div>
              <div class="oli">
                  认证状态：已认证
              </div>
              <div class="oli">
                  状态：<span class="lv">启用</span>
              </div>
              <div class="btn_box">
                  <div class="operation_btn" @click="determineType(1)">停用</div>
                  <div class="info_btn" @click="toDetail(1)">操作</div>
              </div>
          </div> -->
      </div>
      <div class="none" v-if="list.length<=0">
          <img src="../../static/img/wujilu_img.png" alt="">
          暂无司机
      </div>
  </div>
</template>

<script>
import tab from '@/components/NavBar'
import Vue from 'vue';
import { Search } from 'vant';
import { Button } from 'vant';
import { Dialog } from 'vant';
import { Toast } from 'vant';

Vue.use(Toast);
Vue.use(Button);
Vue.use(Search);    
export default {
  name: 'margin',
  data () {
    return {
        value:'',
        list:[]
    }
  },
  components:{
      tab
  },
  mounted(){
      this.value =''
      this.selectDrive('')
  },
  methods:{
    selectDrive(e){
        console.log(e)
        Toast.loading({
            message: '加载中...',
            forbidClick: true,
        });
        var data = {
            driverName:e,
            token:this.$storage.get('token')
        }
        //执行搜索
        this.$api.post("orgapp/getCarDriverList", data, (response) => {
        console.log(response.data);
        if (response.status >= 200 && response.status < 300) {
            console.log(response.data);
            var data = response.data;
            if (data.msg == "success") {
                data.list.forEach(element => {
                    element.balance = (element.balance/100).toFixed(2)
                });
                Toast.clear();
                this.list = data.list
            } else {
                Toast.clear();
                Toast.fail(response.data.msg);
            }
            } else {
                Toast.clear();
                Toast.fail(response.status);
            }
        });
    },
    toDetail(item){
        console.log(item)
        this.$router.push({
            name: "driver_operation",
            params: { item:item},
        });
    },
    determineType(type,id){
        if(type==1){//当前状态为启用，点击后执行停用
            //调用接口停用
            var msg = '确认禁用该加油卡？'
            var status=0
        }
        if(type==0){//当前状态为停用，点击后执行启用
            //调用接口启用
            var msg = '确认启用该加油卡？'
            var status=1
        }
        Dialog.confirm({
            title: '标题',
            message: msg,
        })
        .then(() => {
            // on confirm
            this.enableCarDriver(id,status)
        })
        .catch(() => {
            // on cancel
        });
    },
    enableCarDriver(id,status){
        var data = {
            token:this.$storage.get('token'),
            id:id,
            status:status
        }
        this.$api.post('orgapp/enableCarDriver',data,response=>{
            if (response.status >= 200 && response.status < 300) {
                console.log(response.data)
                var data = response.data
                if(data.msg=='success'){
                    Toast.success('更改成功！');
                    this.value =''
                    this.selectDrive('')
                }
            }
        })
    }
  }
}
</script>

<style scoped>
.main {
    background-color: #F7F8FA;
    height: 100vh;
}
.select_box {
    width: 100%;
    background-color: #fff;
    text-align: center;
}
.card_list {
  width: 93%;
  margin: auto;
}
.card {
  margin-top: 10px;
  width: 100%;
  height: 104px;
  background-color: #fff;
  position: relative;
  color: #000;
  border-radius: 6px;
  font-family: 'SimSun';
}
.cardNo {
  border-bottom: 1px solid #eee;
  height: 30px;
  line-height: 30px;
  padding-left: 10px;
  font-size: 14px;
}
.oli {
  padding-left: 10px;
  height: 25px;
  width: 39%;
  line-height: 25px;
  display: inline-block;
}
.lv {
    color: chartreuse;
}
.red {
    color: #FB0606;
}
.btn_box {
    position: absolute;
    right: 0;
    bottom: 5px;
}
.operation_btn {
    width: 62px;
    height: 28px;
    line-height: 28px;
    text-align: center;
    background-color: #EE0A24;
    display: inline-block;
    margin-right: 5px;
}
#lv {
    background-color:#07C160 ;
}
.info_btn {
  width: 62px;
  height: 28px;
  line-height: 28px;
  text-align: center;
  border-radius: 4px;
  background-color: #1989fa;
  display: inline-block;
  margin-right: 5px;
  color: #fff;
}
#lv {
    background-color: #07C160;
}
.none {
    width: 100px;
    height: 100px;
    margin: auto;
    margin-top: 30px;
    text-align: center;
    font-size: 20px;
}
.none img {
    width: 100%;
    height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/driver_list.vue